// Authentication is handled via HttpOnly cookies set by the server.
// These functions are kept for backward compatibility but no longer store
// sensitive tokens in localStorage.

export const getToken = (): string | null => {
  return null;
};

export const setToken = (_token: string): void => {
  // No-op: auth is cookie-based; token is stored in an HttpOnly cookie by the server.
};

export const removeToken = (): void => {
  // No-op: the server clears the cookie via the /auth/logout endpoint.
};

// isAuthenticated is kept for ProtectedRoute backward compatibility.
// It always returns true here; the actual check is done server-side via validateSession().
export const isAuthenticated = (): boolean => {
  return true;
};
